import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

function ViewButton(props) {
  return (
    <div
      className="square-button view-button-color centered-content button-pointer"
      title="View"
      onClick={props.handleOpen}
    >
      <VisibilityIcon style={{ color: "white" }} />
    </div>
  );
}

export default ViewButton;
